import React from "react";
import { cn } from "@/lib/utils";
import { useNavigate, useLocation, useSearchParams } from "react-router-dom";

interface TabProps {
  title: string;
  href: string;
}

interface TabsProps {
  tabs: TabProps[];
  className?: string;
}

const Tabs: React.FC<TabsProps> = ({ tabs, className }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const bcApplicationId = searchParams.get("bc-request-id");
  return (
    <div className={cn("flex flex-col gap-4 md:flex-row", className)}>
      {tabs.map((tab) => {
        const isActive = bcApplicationId
          ? tab.href === tabs[1].href
          : location.pathname === tab.href || location.pathname.startsWith(tab.href);

        return (
          <div
            key={tab.href}
            onClick={() => navigate(tab.href)}
            className={cn(
              "flex w-full cursor-pointer items-center rounded-lg px-2 py-1 text-center text-sm font-semibold md:w-[11rem]",
              isActive
                ? "bg-secondary text-secondary-foreground"
                : "bg-muted text-muted-foreground hover:bg-secondary hover:text-secondary-foreground",
            )}
          >
            {tab.title}
          </div>
        );
      })}
    </div>
  );
};

export default Tabs;
